
export default {
  props: {
    hideLogo: {
      type: Boolean,
      default: false,
    },
  },
}
